module.exports = __webpack_public_path__ + "img/about_section_image.69a20501.png";